export const isDisplayingNextInvoicePromotion = (apiResponse) => {
  const { subscription, discount } = apiResponse
  return !!(
    subscription &&
    subscription.status === 'active' &&
    !subscription.cancel_at_period_end &&
    discount &&
    discount.coupon
  )
}

export default {
  isDisplayingNextInvoicePromotion,
}
